import { useState } from 'react';

const Body = () => {
  const [numberClickAnd, setNumberClickAnd] = useState([0]);
  return (
    <div>
      body
      <div>
        <div
          className="btn btn-primary"
          //   onClick={() => {
          //     let data = [...numberClickAnd];
          //     data.push(Math.max(...numberClickAnd) + 1);
          //     setNumberClickAnd(data);
          //   }}
        >
          AND
        </div>
      </div>
    </div>
  );
};
export default Body;
